import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import {
  FUNNEL_LABELS,
  FUNNEL_STEPS,
  computeRates,
  detectBottleneck,
  getFunnelSnapshot,
  subscribeFunnel,
} from "@/lib/conversion/funnelEngine";
import { trackEvent } from "@/lib/audit";

export const Route = createFileRoute("/admin/conversion-engine")({
  head: () => ({
    meta: [
      { title: "W-13 Conversion Engine · VerseSport War Room" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ConversionEnginePage,
});

function ConversionEnginePage() {
  const [, force] = useState(0);
  useEffect(() => {
    void trackEvent("conversion_dashboard_opened", {});
    return subscribeFunnel(() => force((n) => n + 1));
  }, []);

  const snap = getFunnelSnapshot();
  const rates = computeRates(snap);
  const bottleneck = detectBottleneck(snap);

  return (
    <main className="min-h-screen bg-background px-4 py-8 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <p className="text-[10px] font-black uppercase tracking-widest text-primary">War Room · W-13</p>
        <h1 className="text-2xl font-black">Conversion Engine</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Visitante → Registro → Nación → Predicción → Recompensa → Share → Referral
        </p>

        {bottleneck ? (
          <div className="mt-4 rounded-2xl border border-destructive/50 bg-destructive/10 p-3 text-xs">
            <div className="text-[10px] font-black uppercase tracking-widest text-destructive">⚠ Cuello de botella</div>
            <div className="mt-1 text-sm font-black">{FUNNEL_LABELS[bottleneck.step]}</div>
            <div className="text-muted-foreground">
              {bottleneck.rate.toFixed(1)}% real · objetivo {bottleneck.target}%
            </div>
          </div>
        ) : (
          <div className="mt-4 rounded-2xl border border-primary/40 bg-primary/10 p-3 text-xs">
            ✅ Sin cuellos de botella detectados (umbral 10 visitas mínimas).
          </div>
        )}

        <section className="mt-6 space-y-2">
          {rates.map((r) => {
            const count = snap.counts[r.step] ?? 0;
            return (
              <article
                key={r.step}
                className="rounded-xl border border-border/60 bg-card p-3"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-[10px] font-black uppercase tracking-widest text-muted-foreground">
                      {FUNNEL_LABELS[r.step]}
                    </div>
                    <div className="text-lg font-black tabular-nums">{count}</div>
                  </div>
                  <div className="text-right">
                    <div className={"text-sm font-black tabular-nums " + (r.ok ? "text-primary" : "text-destructive")}>
                      {r.rate.toFixed(1)}%
                    </div>
                    <div className="text-[10px] text-muted-foreground">objetivo {r.target}%</div>
                  </div>
                </div>
                <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-secondary">
                  <div
                    className={"h-full " + (r.ok ? "bg-primary" : "bg-destructive")}
                    style={{ width: `${Math.max(0, Math.min(100, r.rate))}%` }}
                  />
                </div>
              </article>
            );
          })}
        </section>

        <p className="mt-6 text-[10px] text-muted-foreground">
          Origen: eventos `vs:event` reales del usuario en este dispositivo. País: {snap.country ?? "n/a"}.
          Para vistas globales, agregar `audit_master` por `event_type` en {FUNNEL_STEPS.length} pasos.
        </p>
      </div>
    </main>
  );
}